module.exports = __webpack_public_path__ + "media/images/dashboard-overall-c78a33ac.png";